import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';

import {  Editor, Toolbar } from 'ngx-editor';


@Component({
  selector: 'app-job-post-description',
  templateUrl: './job-post-description.component.html',
  styleUrls: ['./job-post-description.component.scss']
})
export class JobPostDescriptionComponent implements OnInit, OnDestroy{
  ngOnDestroy(): void {

  }
  ngOnInit(): void {

  }

  textControl: FormControl = new FormControl('');

  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];


  gotojobListingpage(){
    window.location.href='/create-job-post'
  }


  gotoJobDescription(){
    window.location.href='/create-job-approver'
  }

}
